export const adminPerms = {
  // Empresas
  seeCompanies: "admin\\cadastro\\empresa\\visualizar",
  addCompanies: "admin\\cadastro\\empresa\\adicionar",
  editCompanies: "admin\\cadastro\\empresa\\editar",
  deleteCompanies: "admin\\cadastro\\empresa\\excluir",

  // Contratos
  seeContracts: "admin\\cadastro\\contrato\\visualizar",
  addContracts: "admin\\cadastro\\contrato\\adicionar",
  editContracts: "admin\\cadastro\\contrato\\editar",
  deleteContracts: "admin\\cadastro\\contrato\\excluir",

  // Items de Contratos
  seeContractsItems: "admin\\cadastro\\item-contrato\\visualizar",
  addContractsItems: "admin\\cadastro\\item-contrato\\adicionar",
  editContractsItems: "admin\\cadastro\\item-contrato\\editar",
  deleteContractsItems: "admin\\cadastro\\item-contrato\\excluir",

  // ECategorias Empresa
  seeCompanyCategory: "admin\\cadastro\\categoria-empresa\\visualizar",
  addCompanyCategory: "admin\\cadastro\\categoria-empresa\\adicionar",
  editCompanyCategory: "admin\\cadastro\\categoria-empresa\\editar",
  deleteCompanyCategory: "admin\\cadastro\\categoria-empresa\\excluir",

  // Inscrição
  seeRegistrations: "admin\\cadastro\\inscricao\\visualizar",
  addRegistrations: "admin\\cadastro\\inscricao\\adicionar",
  editRegistrations: "admin\\cadastro\\inscricao\\editar",
  deleteRegistrations: "admin\\cadastro\\inscricao\\excluir",

  // Planos
  seePlans: "admin\\cadastro\\plano\\visualizar",
  addPlans: "admin\\cadastro\\plano\\adicionar",
  editPlans: "admin\\cadastro\\plano\\editar",
  deletePlans: "admin\\cadastro\\plano\\excluir",

  // Usuários
  seeUsers: "admin\\cadastro\\usuario\\visualizar",
  addUsers: "admin\\cadastro\\usuario\\adicionar",
  editUsers: "admin\\cadastro\\usuario\\editar",
  deleteUsers: "admin\\cadastro\\usuario\\excluir",

  // Gerar senha usuário
  generateUsersPassword: "admin\\cadastro\\usuario\\gerar-senha",

  // Cidades
  seeCities: "admin\\cadastro\\municipio\\visualizar",
  addCities: "admin\\cadastro\\municipio\\adicionar",
  editCities: "admin\\cadastro\\municipio\\editar",
  deleteCities: "admin\\cadastro\\municipio\\excluir",

  // Variáveis de valor
  seeValueVariables: "admin\\cadastro\\variavel\\visualizar",
  addValueVariables: "admin\\cadastro\\variavel\\adicionar",
  editValueVariables: "admin\\cadastro\\variavel\\editar",
  deleteValueVariables: "admin\\cadastro\\variavel\\excluir",

  // Enquetes
  seeSurvey: "admin\\cadastro\\enquete\\visualizar",
  addSurvey: "admin\\cadastro\\enquete\\adicionar",
  editSurvey: "admin\\cadastro\\enquete\\editar",
  deleteSurvey: "admin\\cadastro\\enquete\\excluir",

  // Categorias-site
  seeBlogCategory: "admin\\site\\categoria\\visualizar",
  addBlogCategory: "admin\\site\\categoria\\adicionar",
  editBlogCategory: "admin\\site\\categoria\\editar",
  deleteBlogCategory: "admin\\site\\categoria\\excluir",

  // Blog
  seeBlog: "admin\\site\\blog\\visualizar",
  addBlog: "admin\\site\\blog\\adicionar",
  editBlog: "admin\\site\\blog\\editar",
  deleteBlog: "admin\\site\\blog\\excluir",

  // Comentários
  seeComments: "admin\\site\\comentario\\visualizar",
  addComments: "admin\\site\\comentario\\adicionar",
  editComments: "admin\\site\\comentario\\editar",
  deleteComments: "admin\\site\\comentario\\excluir",

  // Conteúdo Selecionado
  seeContent: "admin\\site\\conteudo\\visualizar",
  addContent: "admin\\site\\conteudo\\adicionar",
  editContent: "admin\\site\\conteudo\\editar",
  deleteContent: "admin\\site\\conteudo\\excluir",

  // Download
  seeDownload: "admin\\site\\download\\visualizar",
  addDownload: "admin\\site\\download\\adicionar",
  editDownload: "admin\\site\\download\\editar",
  deleteDownload: "admin\\site\\download\\excluir",

  // CNAE
  seeCnaes: "admin\\gtfacil\\cnae\\visualizar",
  addCnaes: "admin\\gtfacil\\cnae\\adicionar",
  editCnaes: "admin\\gtfacil\\cnae\\editar",
  deleteCnaes: "admin\\gtfacil\\cnae\\excluir",

  // Códigos de serviço
  seeServiceCodes: "admin\\gtfacil\\codigo-servico\\visualizar",
  addServiceCodes: "admin\\gtfacil\\codigo-servico\\adicionar",
  editServiceCodes: "admin\\gtfacil\\codigo-servico\\editar",
  deleteServiceCodes: "admin\\gtfacil\\codigo-servico\\excluir",

  // Códigos NBS
  seeNbsCodes: "admin\\gtfacil\\nbs\\visualizar",
  addNbsCodes: "admin\\gtfacil\\nbs\\adicionar",
  editNbsCodes: "admin\\gtfacil\\nbs\\editar",
  deleteNbsCodes: "admin\\gtfacil\\nbs\\excluir",

  // Anotações
  seeAnnotations: "admin\\gtfacil\\anotacao\\visualizar",
  addAnnotations: "admin\\gtfacil\\anotacao\\adicionar",
  editAnnotations: "admin\\gtfacil\\anotacao\\editar",
  deleteAnnotations: "admin\\gtfacil\\anotacao\\excluir",

  // Termos de pesquisa
  seeSearchTerms: "admin\\gtfacil\\termo-pesquisa\\visualizar",
  addSearchTerms: "admin\\gtfacil\\termo-pesquisa\\adicionar",
  editSearchTerms: "admin\\gtfacil\\termo-pesquisa\\editar",
  deleteSearchTerms: "admin\\gtfacil\\termo-pesquisa\\excluir",

  // Items de Resposta
  seeAnswerItems: "admin\\gtfacil\\item-resposta\\visualizar",
  addAnswerItems: "admin\\gtfacil\\item-resposta\\adicionar",
  editAnswerItems: "admin\\gtfacil\\item-resposta\\editar",
  deleteAnswerItems: "admin\\gtfacil\\item-resposta\\excluir",

  // Tipos de Resposta
  seeAnswerTypes: "admin\\gtfacil\\tipo-resposta\\visualizar",
  addAnswerTypes: "admin\\gtfacil\\tipo-resposta\\adicionar",
  editAnswerTypes: "admin\\gtfacil\\tipo-resposta\\editar",
  deleteAnswerTypes: "admin\\gtfacil\\tipo-resposta\\excluir",

  // Respostas
  seeAnswers: "admin\\gtfacil\\resposta\\visualizar",
  addAnswers: "admin\\gtfacil\\resposta\\adicionar",
  editAnswers: "admin\\gtfacil\\resposta\\editar",
  deleteAnswers: "admin\\gtfacil\\resposta\\excluir",

  // Respostas ISS
  seeIssAnswers: "admin\\gtfacil\\resposta-iss\\visualizar",
  addIssAnswers: "admin\\gtfacil\\resposta-iss\\adicionar",
  editIssAnswers: "admin\\gtfacil\\resposta-iss\\editar",
  deleteIssAnswers: "admin\\gtfacil\\resposta-iss\\excluir",

  // Importar respostas
  seeAnswerImport: "admin\\gtfacil\\importar-resposta\\visualizar",

  // Informação Fiscal
  seeFiscalInformation: "admin\\gtfacil\\informacao-fiscal\\visualizar",
  useIfAiFiscalInformation: "admin\\gtfacil\\informacao-fiscal\\consultar-ia",

  // Perfis de usuário
  seeUserProfile: "admin\\cadastro\\perfil-usuario\\visualizar",
  addUserProfile: "admin\\cadastro\\perfil-usuario\\adicionar",
  editUserProfile: "admin\\cadastro\\perfil-usuario\\editar",
  deleteUserProfile: "admin\\cadastro\\perfil-usuario\\excluir",

  // Vídeos Explicativos
  seeExplanatoryVideo: "admin\\site\\video\\visualizar",
  addExplanatoryVideo: "admin\\site\\video\\adicionar",
  editExplanatoryVideo: "admin\\site\\video\\editar",
  deleteExplanatoryVideo: "admin\\site\\video\\excluir",

  // Categorias de Vídeo Explicativo
  seeExplanatoryVideoCategory: "admin\\site\\categoria-video\\visualizar",
  addExplanatoryVideoCategory: "admin\\site\\categoria-video\\adicionar",
  editExplanatoryVideoCategory: "admin\\site\\categoria-video\\editar",
  deleteExplanatoryVideoCategory: "admin\\site\\categoria-video\\excluir",

  // Auditoria
  seeAudit: "admin\\auditoria\\visualizar",
  exportAudit: "admin\\auditoria\\exportar",
};

// CLIENTE
export const clientPerms = {
  // Perfis
  seeUserProfile: "client\\cadastro\\perfil-usuario\\visualizar",
  addUserProfile: "client\\cadastro\\perfil-usuario\\adicionar",
  deleteUserProfile: "client\\cadastro\\perfil-usuario\\excluir",
  editUserProfile: "client\\cadastro\\perfil-usuario\\editar",

  // Usuários
  seeUsers: "client\\painel\\usuario\\visualizar",
  addUsers: "client\\painel\\usuario\\adicionar",
  editUsers: "client\\painel\\usuario\\editar",
  deleteUsers: "client\\painel\\usuario\\excluir",

  // Informação Fiscal
  seeFiscalInformation: "client\\painel\\informacao-fiscal\\visualizar",
  addFiscalInformation: "client\\painel\\informacao-fiscal\\adicionar",

  // Estatisticas / Informação
  seeStats: "client\\painel\\estatisticas\\visualizar",

  // Pesquisa CNAE
  seeCnaeResearch: "client\\gtfacil\\pesquisa-cnae\\visualizar",

  // Pesquisa CNPJ
  seeCnpjResearch: "client\\gtfacil\\pesquisa-cnpj\\visualizar",

  // Pesquisa LC
  seeLcResearch: "client\\gtfacil\\pesquisa-lc\\visualizar",

  // Pesquisa Livre
  seeFreeSearch: "client\\gtfacil\\pesquisa-livre\\visualizar",

  // Pesquisa Avançada
  plusSearch: "client\\gtfacil\\pesquisa-plus\\visualizar",

  //Visualizar Tributos CBS IBS
  seeTributesCBSIBSview: "client\\gtfacil\\ibs_cbs\\visualizar",

  //Visualizar Códigos NBS
  seeTributesNBSview: "client\\gtfacil\\nbs\\visualizar",

  // Legislação
  seeLegislation: "client\\conteudo-selecionado\\legislacao\\visualizar",

  // Artigos
  seeArticles: "client\\conteudo-selecionado\\artigos\\visualizar",

  // Multimídea
  seeMultimedia: "client\\conteudo-selecionado\\multimidia\\visualizar",

  // Blog
  seeBlog: "client\\conteudo-selecionado\\blog\\visualizar",
};

// REINF
export const reinfPerms = {
  // Empresa
  seeCompany: "reinf\\empresa\\visualizar",
  editCompany: "reinf\\empresa\\editar",

  //Estabelecimentos
  addEstablishment: "reinf\\estabelecimento\\adicionar",
  editEstablishment: "reinf\\estabelecimento\\editar",
  deleteEstablishment: "reinf\\estabelecimento\\excluir",
  editManagerEstablishments: "reinf\\estabelecimento\\gerenciar",

  //Parceiros de negócio
  seeBusinessPartner: "reinf\\parceiros-negocio\\visualizar",
  addBusinessPartner: "reinf\\parceiros-negocio\\adicionar",
  editBusinessPartner: "reinf\\parceiros-negocio\\editar",
  deleteBusinessPartner: "reinf\\parceiros-negocio\\excluir",

  //Processos judiciais R-1070
  seeProcessCases: "reinf\\processos-judiciais\\visualizar",

  //Envios
  sendR1000: "reinf\\envio\\r1000",
  sendR2010: "reinf\\envio\\r2010",
  sendR2020: "reinf\\envio\\r2020",
  sendR2055: "reinf\\envio\\r2055",
  sendR2098: "reinf\\envio\\r2098",
  sendR2099: "reinf\\envio\\r2099",
  sendR4010: "reinf\\envio\\r4010",
  sendR4020: "reinf\\envio\\r4020",
  sendR4099: "reinf\\envio\\r4099",
  sendR1070: "reinf\\envio\\r1070",
  sendR9000: "reinf\\envio\\r9000",
  seeEventsHistory: "reinf\\envio\\historico",

  //Certificados digitais
  seeCertificate: "reinf\\certificado-digital\\visualizar",
  addCertificate: "reinf\\certificado-digital\\adicionar",
  editCertificate: "reinf\\certificado-digital\\editar",
  deleteCertificate: "reinf\\certificado-digital\\excluir",

  //Importar Docs
  importXml: "reinf\\importacao\\xml",
  importSpreadsheet: "reinf\\importacao\\planilha",

  //Consultar situação protocolos
  checkProtocol: "reinf\\consulta\\protocolo",

  //Protocolos de envio
  seeProtocols: "reinf\\protocolo\\visualizar",

  //Documentos Fiscais
  seeFiscalDocument: "reinf\\documento-fiscal\\visualizar",
  addFiscalDocument: "reinf\\documento-fiscal\\adicionar",
  deleteFiscalDocument: "reinf\\documento-fiscal\\excluir",
  editFiscalDocument: "reinf\\documento-fiscal\\editar",

  //Configurações
  editConfigs: "reinf\\configuracoes\\editar",
  deleteAllNfse: "reinf\\configuracoes\\limpar-base-docs",
  deleteAllPayments: "reinf\\configuracoes\\limpar-base-pagamentos",
};

export const securityErrorMessage = (message) => "Não possui permissão para " + message;
